/*
 * @Author: chg
 * @LastEditors: chg
 * @LastEditTime: 2023-11-21 09:58:52
 * @Description: 事件回测API
 */
import http from '../../utils/http.js'

// 发起事件解析
export function ParseEvent (params) {
  const url = '/gptEvent/parseEvent'
  return http.post(url, params)
}

// 获取事件信息
export function GetEvent (params) {
  const url = '/gptEvent/getEvent'
  return http.get(url, params)
}

// 解析事件回测函数
export function GenerateFactor (params) {
  const url = '/gptEvent/generateFactor'
  return http.post(url, params)
}

// 通过expression_id获取数据id (id之后获取曲线详情）
export function GetIndexInfoByExpressionId (params) {
  const url = '/refactor/getIndexInfoByExpressionId'
  return http.get(url, params)
}

// 通过数据id获取曲线详情
export function RequestIndexDetail (params) {
  const url = '/timeSeries/requestIndexDetail'
  return http.get(url, params)
}



// WEBPACK FOOTER //
// ./src/api/whiteList/eventBack.js